/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/DailyChallengeProgressMeter',['pixi', 'absolute', 'absolute/storagemanager', 'lodash', 'tween', 'MenuUI/DropShadow',
    'Solitaire/MvvmStructure/Service/SolitaireDailyChallengeService', 'absolute/particleemitter',
    'MenuUI/BadgeEarnedDialog', 'util/SettingsManager', 'MenuUI/MsftButton', 'absolute/stringmanager',
    'Managers/TelemetryManager', 'util/NineSliceButton'],

    function (PIXI, Absolute, StorageManager, _, TWEEN, DropShadow, SolitaireDailyChallengeService,
        ParticleEmitter, BadgeEarnedDialog, SettingsManager, MsftButton, _s, TelemetryManager, NineSliceButton) {

        var DailyChallengeProgressMeter = function (config, parent, ui) {

            const textScale = config.scale || 1;

            var defaultConfig = {
                scale: 1,
                width: 1823,
                height: 300, // Total Height
                padding: 20,
                spacing: 20,
                textSpacing: 10,
                badgeSize: 60,
                progressBarHeight: 40,
                primaryFontSize: 34,
                secondaryFontSize: 24,

                possibleCoins: 10000,

                month: '',

                letterStyle1: {
                    font: Absolute.ScreenMetrics.getResScale() * 24 * textScale + 'px Arial',
                    fontFamily: 'segoe',
                    fill: '#749dd2',
                    tint: 0x749dd2,
                    align: 'left'
                },
                letterStyle2: {
                    font: Absolute.ScreenMetrics.getResScale() * 34 * textScale + 'px Arial',
                    fontFamily: 'segoe',
                    fill: '#ffffff',
                    tint: 0xffffff,
                    align: 'left'
                },
                letterStyle3: {
                    font: Absolute.ScreenMetrics.getResScale() * 24 * textScale + 'px Arial',
                    fontFamily: 'segoe',
                    fill: '#ffffff',
                    tint: 0xffffff,
                    align: 'left'
                }
            };
            this.initDailyChallengeProgressMeter(_.extend(defaultConfig, config), parent, ui);
        };

        DailyChallengeProgressMeter.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);

        DailyChallengeProgressMeter.prototype.initDailyChallengeProgressMeter = function (config, parent, ui) {

            PIXI.DisplayObjectContainer.call(this);

            this.controls = [];

            this.config = config;
            // this.config.scale = 2;
            this.config.height *= this.config.scale;
            this.config.textSpacing *= this.config.scale;
            this.config.progressBarHeight *= this.config.scale;
            this.dailyChallengeMenu = parent;
            this.ui = ui;

            // this is supplemented with more data in updateStats
            this.medalsData = [
                {
                    id: 'Bronze',
                    texture: 'DC_goal_meter_bronze.png'

                },
                {
                    id: 'Silver',
                    texture: 'DC_goal_meter_silver.png'

                },
                {
                    id: 'Gold',
                    texture: 'DC_goal_meter_gold.png'

                },
                {
                    id: 'Diamond',
                    texture: 'DC_goal_meter_diamond.png'

                }
            ];

            var dropShadow = new DropShadow({
                baseWidth: Absolute.Coords.x(this.config.width),
                baseHeight: Absolute.Coords.y(this.config.height)
            }),
                background = new PIXI.Graphics();

            background.beginFill(0x10396d);
            background.drawRect(0, 0, Absolute.Coords.x(this.config.width), Absolute.Coords.y(this.config.height));
            background.endFill();

            // keep stuff around so we can clean it up later
            this.movieClips = [];
            this.tweens = [];
            this.particleLayer = new PIXI.DisplayObjectContainer();
            this.movieClipLayer = new PIXI.DisplayObjectContainer();

            this.addChild(dropShadow);
            this.addChild(background);

            this.updateStats();
            this.buildProgressBar();
            this.buildMedals();
            this.buildLabels();

        };

        DailyChallengeProgressMeter.prototype.getControls = function () {
            return this.controls.sort(function (a, b) {
                return a.x - b.x;
            });
        };

        DailyChallengeProgressMeter.prototype.buildProgressBar = function () {

            this.progressBar = new PIXI.DisplayObjectContainer();

            const barBackground = PIXI.Sprite.fromFrame('dailychallenge/DC_goal_meter_empty.png');
            barBackground.y = Absolute.Coords.y(this.config.padding + this.config.badgeSize);
            this.progressBar.addChild(barBackground);
            this.barFillWidth = barBackground.width - Absolute.Coords.x(8);

            const barCenterTexture = new PIXI.Texture.fromFrame('dailychallenge/DC_goal_meter_fill.png');


            const barFillContainer = new PIXI.DisplayObjectContainer();

            const barCapLeft = PIXI.Sprite.fromFrame('dailychallenge/DC_goal_meter_fill_endcap.png');
            barFillContainer.addChild(barCapLeft);

            const barCapRight = PIXI.Sprite.fromFrame('dailychallenge/DC_goal_meter_fill_endcap.png');
            barCapRight.scale.x = -1;
            barFillContainer.addChild(barCapRight);

            const barCenter = new PIXI.TilingSprite(barCenterTexture,
                this.barFillWidth - barCapLeft.width - barCapRight.width,
                barCenterTexture.height);
            barCenter.x = barCapLeft.width;
            barCapRight.x = barCapLeft.width + barCenter.width - barCapRight.width;

            barFillContainer.addChild(barCenter);


            this.barFill = new PIXI.Sprite(barFillContainer.generateTexture());
            this.barFill.x = Absolute.Coords.x(4);
            this.barFill.y = barBackground.y + Absolute.Coords.x(4);

            const barFillMask = new PIXI.Graphics();
            this.barFillMaskOffset = -this.barFill.width;
            barFillMask.beginFill(0x000000, 0.5);
            barFillMask.drawRect(0, 0, this.barFill.width, barCenter.height);
            barFillMask.endFill();
            barFillMask.x = this.barFillMaskOffset;

            this.barFill.mask = barFillMask;
            this.barFill.addChild(barFillMask);
            this.progressBar.addChild(this.barFill);


            this.barPip = PIXI.Sprite.fromFrame('dailychallenge/DC_goal_meter_playerpip.png');
            this.barPip.y = barBackground.y - Absolute.Coords.x(15);
            this.barPip.scale.x = this.config.scale;
            this.barPip.anchor.x = 0.5;
            this.focusSetter(this.barPip);
            this.barPip.infoBox = this.getInfoBox();
            this.barPip.addChild(this.barPip.infoBox);
            this.bindInteraction(this.barPip, function () {
                this.barPip.infoBox.openBox(this.config);
            }.bind(this));
            this.progressBar.addChild(this.barPip);

            this.progressBar.x = Absolute.Coords.x(47);
            // this.progressBar.y = Absolute.Coords.x(15);
            this.progressBar.y = Absolute.Coords.y(this.config.padding);
            this.progressBar.scale.y = this.config.scale;

            this.addChild(this.progressBar);
            this.controls.push(this.barPip);
        };

        DailyChallengeProgressMeter.prototype.getInfoBox = function (coinsNeeded, targetCoinsOnly, letterStyleOverride) {
            // medal info box
            var infoBoxContainer = new PIXI.DisplayObjectContainer(),
                infoBox = new PIXI.Graphics(),
                offSet = Absolute.Coords.x(30),
                currency = PIXI.Sprite.fromFrame('DC_kickoff_coin.png'),
                multiply = new PIXI.Text('x', this.config.letterStyle1),
                number;
            currency.scale.set(0.6, 0.6);
            multiply.anchor.set(0.5, 0.5);

            if (coinsNeeded && targetCoinsOnly) {
                number = new PIXI.Text(coinsNeeded + ' ' + Absolute.StringManager('DailyChallenge.needed'), _.cloneDeep(letterStyleOverride));
                _s.shrinkToFit(number, _s.extractNumbersFromString(letterStyleOverride.font), '', Absolute.ScreenMetrics.getResScale() * 200);
            } else if (coinsNeeded) {
                number = new PIXI.Text(this.stats.coinsEarned.toString() + ' / ' + coinsNeeded, _.cloneDeep(this.config.letterStyle1));
            } else {
                number = new PIXI.Text(this.stats.coinsEarned.toString(), _.cloneDeep(this.config.letterStyle1));
            }
            // number.anchor.set(0.5, 0.5);

            infoBox.beginFill(0x000000);
            infoBox.lineStyle(1, 0xffffff, 1);
            infoBox.drawRect(0, 0, Absolute.Coords.x(300 + 300 * ((this.config.scale-1)/3)), Absolute.Coords.x(80));
            infoBox.endFill();
            currency.x = offSet;
            currency.y = (infoBox.height - currency.height) / 2;
            multiply.x = currency.x + currency.width + multiply.width / 2 + Absolute.Coords.x(10);
            multiply.y = currency.y + currency.height / 2 + Absolute.Coords.y(2);
            number.x = multiply.x + multiply.width / 2 + Absolute.Coords.x(10);
            number.y = multiply.y - number.height / 2 + Absolute.Coords.y(2);
            if (!targetCoinsOnly) {
                infoBoxContainer.addChild(infoBox);
            }
            infoBoxContainer.addChild(currency);
            infoBoxContainer.addChild(multiply);
            infoBoxContainer.addChild(number);
            infoBoxContainer.visible = false;
            infoBoxContainer.y = -infoBoxContainer.height;
            infoBoxContainer.icon = currency;
            infoBoxContainer.coinCount = number;
            infoBoxContainer.multiply = multiply;
            infoBoxContainer.background = infoBox;

            infoBoxContainer.openBox = function (config) {
                infoBoxContainer.visible = !infoBoxContainer.visible;
                if (infoBoxContainer.visible) {
                    infoBoxContainer.x = 50;
                    infoBoxContainer.updateTransform();
                    var positionTo = 0;
                    if (infoBoxContainer.worldTransform.tx > config.width/2) {
                        positionTo = -(config.width/20);
                        if (infoBoxContainer.worldTransform.tx > config.width*3/4) {
                            positionTo = -(config.width/15);
                        }
                    }
                    var positionFrom = Absolute.Coords.x(50) + positionTo;
                    new TWEEN.Tween({ x: positionFrom })
                        .easing(TWEEN.Easing.Cubic.InOut)
                        .to({ x: positionTo }, 500)
                        .onUpdate(function () {
                            infoBoxContainer.x = this.x;
                            infoBoxContainer.updateTransform();
                        })
                        .start();
                    window.setTimeout(function () {
                        infoBoxContainer.visible = false;
                    }, 3000);
                }
            };

            return infoBoxContainer;
        };

        DailyChallengeProgressMeter.prototype.buildMedals = function () {
            var medalNest = 'dailychallenge/DC_goal_meter_medalnest.png';

            this.medalReferences = {};

            _.each(this.medalsData, function (medal) {
                var medalForeground = PIXI.Sprite.fromFrame(medal.texture),
                    medalBackground = PIXI.Sprite.fromFrame(medalNest),
                    medalContainer = new PIXI.DisplayObjectContainer();


                medalForeground.x = (medalBackground.width - medalForeground.width) / 2;
                medalForeground.y = Absolute.Coords.y(6);
                medalContainer.addChild(medalBackground);
                medalContainer.addChild(medalForeground);
                medal.sprite = new PIXI.Sprite(medalContainer.generateTexture());
                medal.sprite.anchor.x = 0.5;
                medal.sprite.x = (medal.coinsNeeded / this.totalPossibleCoins) * this.barFillWidth;
                // medal.sprite.y = Absolute.Coords.y(this.config.padding);
                medal.sprite.alpha = 0.6;
                medal.infoBox = this.getInfoBox(medal.coinsNeeded.toString());
                medal.sprite.addChild(medal.infoBox);
                this.bindInteraction(medal.sprite, function () {
                    if (DailyChallengeProgressMeter.lastInfoBox) DailyChallengeProgressMeter.lastInfoBox.visible = false;
                    DailyChallengeProgressMeter.lastInfoBox = medal.infoBox;
                    Absolute.AudioManager.playSound('button');

                    var notearned = false;

                    medal.infoBox.openBox(this.config);

                    if (medal.infoBox.visible) {

                        if (medal.sprite.alpha === 0.6) {
                            medal.sprite.alpha = 1;
                            notearned = true;
                        }

                        medal.sprite.interactive = false;

                        window.setTimeout(function () {
                            medal.sprite.interactive = true;
                            if (notearned) {
                                medal.sprite.alpha = 0.6
                            }
                        }, 3000);
                    }

                });
                medal.sprite.scale.x = this.config.scale;
                this.progressBar.addChild(medal.sprite);
                this.controls.push(medal.sprite);
                this.focusSetter(medal.sprite);
                this.medalReferences[medal.id] = medal;
            }, this);

            this.progressBar.addChild(this.barPip);
        };

        DailyChallengeProgressMeter.prototype.focusSetter = function (obj) {
            Object.defineProperty(obj, "focus", {
                get: function () {
                    return obj._hasFocus;
                }.bind(this),
                set: function (value) {
                    obj._hasFocus = value;
                    this._focusChanged(obj);
                    return value;
                }.bind(this)
            });
        };

        DailyChallengeProgressMeter.prototype.updateProgress = function (challengeTiles) {

            var targetX = (this.stats.coinsEarned / this.totalPossibleCoins) * this.barFillWidth,
                barFillTargetX = this.barFillMaskOffset + targetX,
                pipTargetX = this.barFill.x + targetX,
                self = this;

            if (this.stats.coinsEarned_dirty && challengeTiles) {

                /**
                 * 1. X badge
                 * 2. X sparks shoot coin: repeat n times
                 * 3. coins hit progress bar and spark again
                 * 4. once all coins reach meter another blast and then move the meter
                 */

                // pip propulsion particles aka pip poof or pipPoof
                var textures = [PIXI.Texture.fromFrame('Star.png'), PIXI.Texture.fromFrame('Star_orng_dot.png'), PIXI.Texture.fromFrame('Star_pink_dot.png'), PIXI.Texture.fromFrame('Star_teal_dot.png'), PIXI.Texture.fromFrame('Star_yellow_dot.png')],
                    particleOptions = {
                        rate: { numpan: { a: 2, b: 4, center: true }, timepan: { a: 0.01, b: 0.002, center: null } },
                        mass: 1,
                        rotation: { a: [0, 1], b: [0, 3], style: 'add' },
                        velocity: [0.1, 0.2, 0.5],//{ rpan: {a: 0, b: 1, center: null}, thapan: { a: 0, b: 360, center: null}, type: 'polar' },
                        //velocityAngleRange: [185,355],
                        alpha: { a: 0.5, b: 0 },
                        scale: { a: [0.15, 0.15, 0.05], b: 0, center: null },
                        gravity: 0,
                        life: { a: 1, b: 2, center: null },
                        radius: 1,
                        //parent: this.particleLayer,
                        crossZone: null,
                        randomDrift: null
                    },
                    pipEmitter = new ParticleEmitter(this.ui, textures, particleOptions),
                    glow = PIXI.Sprite.fromFrame('ball.png');


                glow.anchor.x = 1;
                glow.anchor.y = 0.5;
                glow.y = pipEmitter.y = this.barPip.y + Absolute.Coords.x(15) * this.config.scale;
                glow.x = this.barPip.x;
                pipEmitter.x = this.barPip.x;
                pipEmitter.alpha = glow.alpha = 0;

                this.particleLayer.addChild(pipEmitter);
                this.particleLayer.addChild(glow);
                this.showDCFirstCompleteDialog();

                this.animateCoins(challengeTiles, function () {
                    var fillTween = new TWEEN.Tween({
                        x: this.barFill.mask.x,
                        pipX: this.barPip.x,
                        coins: this.stats.coinsEarned_old
                    })
                        .delay(100)
                        .easing(TWEEN.Easing.Cubic.In)
                        .to({ x: barFillTargetX, pipX: pipTargetX, coins: this.stats.coinsEarned }, 500)
                        .onStart(function () {
                            Absolute.AudioManager.playSound('CoinProgress_A');
                        })
                        .onUpdate(function () {
                            self.barFill.mask.x = this.x;
                            self.barPip.x = this.pipX;
                            self.coinsValue.setText(Math.round(this.coins).toString());
                        })
                        .onComplete(function () {
                            self.checkForMedalsEarned(true, function () {

                                // look more callbacks! oh yeah! :P

                                if (self.triggerBonus && SettingsManager.getSetting('general', 'showDayBonusFUE')) {
                                    var moreCoinsDialog = new BadgeEarnedDialog(self.ui, self.parent.game,
                                        {
                                            dialog: 'MoreCoinsDialog',
                                            offsetX: Absolute.Coords.x(10),
                                            offsetY: Absolute.Coords.y(10),
                                            closeHandler: function () {
                                                self.stats.coinsEarned_dirty = true;
                                                self.stats.coinsEarned_old = self.stats.coinsEarned;
                                                self.stats.coinsEarned += self.stats[self.currentDate + '_bonus'];
                                                self.stats[self.currentDate + '_challengesComplete_dirty'] = false;
                                                // adding a short time out here to allow the scene graph to get updated
                                                // after the dialog closes. seems to only affect ie11
                                                window.setTimeout(function () {
                                                    self.updateProgress(self.dailyChallengeMenu.challengeTiles);
                                                }, 100);

                                            }.bind(self)
                                        });
                                    // calendar button

                                    moreCoinsDialog.addButtons([
                                        {
                                            'text': _s('DailyChallenge.calendar'),
                                            'threeSlice': moreCoinsDialog.buttonThreeSlice,
                                            'width': 180, 'height': 36,
                                            'position': { "x": 850, "y": 650 },
                                            'action': function () {
                                                moreCoinsDialog.close();
                                                self.dailyChallengeMenu.tabSelected(self.dailyChallengeMenu.tabs[1]);
                                            }.bind(this)
                                        }
                                    ]);

                                    //
                                    var bonusEarnedDialog = new BadgeEarnedDialog(self.ui, self.parent.game,
                                        {
                                            offsetX: Absolute.Coords.x(10),
                                            offsetY: Absolute.Coords.y(10),
                                            dialog: 'BonusEarnedDialog',
                                            closeHandler: function () {
                                                setTimeout(function () {
                                                    moreCoinsDialog.open();
                                                }, 0);
                                            }.bind(self)
                                        });

                                    bonusEarnedDialog.open();
                                    SettingsManager.setSetting('general', 'showDayBonusFUE', false);
                                    self.triggerBonus = false;

                                } else if (self.triggerBonus) {
                                    self.triggerBonus = false;
                                    self.stats.coinsEarned_dirty = true;
                                    self.stats.coinsEarned_old = self.stats.coinsEarned;
                                    self.stats.coinsEarned += self.stats[self.currentDate + '_bonus'];
                                    self.stats[self.currentDate + '_challengesComplete_dirty'] = false;
                                    Absolute.AudioManager.playSound('dc_coinsToBar');
                                    self.updateProgress(self.dailyChallengeMenu.challengeTiles);
                                } else if (self.stats.perfectMonth) {

                                    var perfectEarnedDialog = new BadgeEarnedDialog(self.ui, self.parent.game,
                                        {
                                            offsetX: Absolute.Coords.x(10),
                                            offsetY: Absolute.Coords.y(10),
                                            dialog: 'PerfectEarnedDialog',
                                            closeHandler: function () {
                                            }
                                        });

                                    perfectEarnedDialog.open();
                                }
                            });
                        });

                    var emitterTween = new TWEEN.Tween({ alpha: 0, x: pipEmitter.x + Absolute.Coords.x(50) })
                        .delay(100)
                        .easing(TWEEN.Easing.Circular.Out)
                        .to({ alpha: [0, 0, 0, 1, 1, 1, 0], x: pipEmitter.x - Absolute.Coords.x(110) }, 5500)
                        .onStart(function () {
                            pipEmitter.start();
                            fillTween.start();
                            window.setTimeout(function () {
                                pipEmitter.stop();
                            }, 600);
                        })
                        .onUpdate(function () {
                            pipEmitter.alpha = this.alpha;
                            pipEmitter.x = this.x;
                        })
                        .onComplete(function () {
                            try {
                                self.progressBar.removeChild(pipEmitter);
                                self.progressBar.removeChild(glow);
                            } catch (e) {
                            }
                            pipEmitter.destroy();
                            pipEmitter = null;
                        })
                        .start();


                    var flashTween = new TWEEN.Tween({ alpha: 0, scaleX: 0, scaleY: 0, x: glow.x })
                        .delay(400)
                        .easing(TWEEN.Easing.Cubic.Out)
                        .to({
                            alpha: [0.1, 0, 0.2, 0],
                            scaleX: [1.3, 0.75],
                            scaleY: [0.75, 0.5],
                            x: glow.x + Absolute.Coords.x(70)
                        }, 1800)
                        .onStart(function () {
                            /* pipEmitter.start();
                             window.setTimeout(function(){
                                 pipEmitter.stop();
                             }, 300);*/
                        })
                        .onUpdate(function () {
                            glow.scale.x = this.scaleX;
                            glow.scale.y = this.scaleY;
                            //glow.x = this.x;
                            glow.alpha = this.alpha;
                        })
                        .start();

                    this.tweens.push(fillTween);
                    this.tweens.push(emitterTween);
                    this.tweens.push(flashTween);

                }.bind(this));

                this.stats.coinsEarned_dirty = false;

            } else {
                this.coinsValue.setText(this.stats.coinsEarned.toString());
                this.barFill.mask.x = barFillTargetX;
                this.barPip.x = pipTargetX;
                this.checkForMedalsEarned(false);
            }
            this.daysRemainingValue.setText(DailyChallengeProgressMeter.getDaysRemaining().toString());
            this.challengesCompleteValue.setText(this.stats.completedChallenges.toString() + ' / ' + this.stats.totalChallenges.toString());
            this.barPip.infoBox.coinCount.setText(this.stats.coinsEarned.toString());

        };

        DailyChallengeProgressMeter.prototype.showDCFirstCompleteDialog = function () {
            var dCFirstCompleteFUESeen = StorageManager.fetch('dCFirstCompleteFUESeen');
            if (!dCFirstCompleteFUESeen) {
                var dialog = new BadgeEarnedDialog(this.ui, this.dailyChallengeMenu.game,
                    {
                        offsetX: Absolute.Coords.x(10),
                        offsetY: Absolute.Coords.y(10),
                        dialog: 'DCFirstCompleteDialog',
                        closeHandler: function () {
                            StorageManager.store('dCFirstCompleteFUESeen', true);
                        }.bind(this),
                        isDCFirstCompleteDialog: true
                    });
                dialog.open();
            }
        };

        DailyChallengeProgressMeter.prototype.sendBadgeAwardedTelemetry = function (medal) {
            SolitaireDailyChallengeService.UpdateGlobalChallengeStats();
            var globals = SolitaireDailyChallengeService.GetGlobalChallengeStats();
            var currentDate = new Date();
            TelemetryManager.badgeAwarded(
                medal.id, currentDate.getMonth() + 1, currentDate.getFullYear(),
                globals.bronzeBadgesWon, globals.silverBadgesWon, globals.goldBadgesWon,
                globals.diamondBadgesWon, globals.perfectCompletions, globals.klondikeChallenges,
                globals.spiderChallenges, globals.freecellChallenges, globals.pyramidChallenges,
                globals.tripeaksChallenges, globals.easyChallenges, globals.mediumChallenges,
                globals.hardChallenges, globals.expertChallenges
            )
        };

        DailyChallengeProgressMeter.prototype.checkForMedalsEarned = function (dirty, callback) {

            var callbackSet = false;
            _.each(this.medalsData, function (medal) {
                if (this.stats.coinsEarned >= medal.coinsNeeded) {
                    medal.infoBox.coinCount.setText(Absolute.StringManager('DailyChallenge.' + medal.id + 'Earned'));
                    medal.infoBox.coinCount.updateText();
                    _s.shrinkToFit(medal.infoBox.coinCount, _s.extractNumbersFromString(this.config.letterStyle1.font),
                        '', Absolute.ScreenMetrics.getResScale() * 270);
                    medal.infoBox.coinCount.x = (medal.infoBox.background.width - medal.infoBox.coinCount.width) / 2;
                    medal.infoBox.icon.visible = false;
                    medal.infoBox.multiply.visible = false;
                    if (!medal.earned) this.sendBadgeAwardedTelemetry(medal);
                    if (!medal.earned && dirty) {
                        callbackSet = true;
                        medal.earned = true;

                        var //textures = [PIXI.Texture.fromFrame('Star.png'), PIXI.Texture.fromFrame('time glow.png')],
                            textures = [PIXI.Texture.fromFrame('Star.png'), PIXI.Texture.fromFrame('Star_orng_dot.png'), PIXI.Texture.fromFrame('Star_pink_dot.png'), PIXI.Texture.fromFrame('Star_teal_dot.png'), PIXI.Texture.fromFrame('Star_yellow_dot.png')],
                            rate = { numpan: { a: 5, b: 8, center: true }, timepan: { a: 0.008, b: 0.015, center: null } },
                            velocity = 0.65,// = { rpan: {a: 1, b: 1, center: true}, thapan: { a: 0, b: 360, center: true}, type: 'polar' },
                            scale = { a: [0.5, 0.2, 0.2, 0.2], b: 0.0, center: null },
                            radius = 1,
                            rate2 = { numpan: { a: 50, b: 100, center: null }, timepan: { a: 0.1, b: 0.2, center: null } },
                            velocity2 = [4, 3, 2, 1],//{ rpan: {a: 3, b: 4, center: null}, thapan: { a: 0, b: 360, center: null}, type: 'polar' },
                            alpha = { a: 0.5, b: 0 },
                            rotation = { a: [5, 10, 15, 20, 25, 30, 35, 40, 45], b: [0, 3], style: 'add' },
                            life = { a: 0, b: 1, center: null },
                            emitter = new ParticleEmitter(this.ui, textures, {
                                rate: rate,
                                mass: 1,
                                rotation: rotation,
                                velocity: velocity,
                                alpha: alpha,
                                scale: scale,
                                gravity: 0,
                                life: life,
                                radius: radius,
                                parent: this.particleLayer,
                                crossZone: null,
                                randomDrift: null
                            }),
                            emitter2 = new ParticleEmitter(this.ui, textures, {
                                rate: rate2,
                                mass: 1,
                                rotation: rotation,
                                velocity: velocity2,
                                alpha: alpha,
                                scale: scale,
                                gravity: 2,
                                life: life,
                                radius: radius,
                                parent: this.particleLayer,
                                crossZone: null,
                                randomDrift: null
                            }),
                            self = this,
                            endX = medal.sprite.x,
                            endY = medal.sprite.y + Absolute.Coords.y(40),
                            gridSpace = Absolute.Coords.x(120),

                            spiralX0 = endX + gridSpace * 1,
                            spiralX1 = endX - gridSpace * 0,
                            spiralX2 = endX - gridSpace * 3.5,
                            spiralX3 = endX,
                            spiralX4 = endX + gridSpace * 3,
                            spiralX5 = endX,
                            spiralX6 = endX - gridSpace * 1.75,
                            spiralX7 = endX - gridSpace / 2,

                            spiralY0 = endY - gridSpace * 0,
                            spiralY1 = endY - gridSpace * 3.3,
                            spiralY2 = endY,
                            spiralY3 = endY + gridSpace * 3.5,
                            spiralY4 = endY,
                            spiralY5 = endY - gridSpace * 3,
                            spiralY6 = endY,
                            spiralY7 = endY + gridSpace / 2,
                            glow = PIXI.Sprite.fromFrame('ball.png');

                        this.progressBar.addChild(emitter);
                        this.progressBar.addChild(emitter2);
                        this.progressBar.addChild(glow);
                        glow.alpha = 0;
                        emitter.start();
                        emitter.x = spiralX0;
                        emitter.y = spiralY0;
                        emitter2.x = endX;
                        emitter2.y = endY;
                        glow.anchor.x = glow.anchor.y = 0.5;
                        glow.x = endX;
                        glow.y = endY;

                        var spiralTween = new TWEEN.Tween({ x: spiralX0, y: spiralY0 })
                            .easing(TWEEN.Easing.Cubic.In)
                            .to({
                                x: [spiralX1, spiralX2, spiralX3, spiralX4, spiralX5, spiralX6, spiralX7, endX],
                                y: [spiralY1, spiralY2, spiralY3, spiralY4, spiralY5, spiralY6, spiralY7, endY]
                            }, 1700)
                            .onUpdate(function () {
                                emitter.x = this.x;
                                emitter.y = this.y;
                            })
                            .onComplete(function () {
                                window.setTimeout(function () {
                                    emitter2.emitOnce();
                                }, 500);
                                emitter.stop();
                            })
                            .interpolation(TWEEN.Interpolation.Bezier)
                            .start();

                        var medalEarnedTween = new TWEEN.Tween({ alpha: 1, scale: 0 })
                            .delay(50)
                            .easing(TWEEN.Easing.Exponential.Out)
                            .to({ alpha: [1, 1, 0], scale: 1.5 }, 800)
                            .onStart(function () {
                                window.setTimeout(function () {
                                    medal.sprite.alpha = 1;
                                }, 400);
                            })
                            .onUpdate(function () {
                                glow.scale.x = glow.scale.y = this.scale;
                                glow.alpha = this.alpha;
                            })
                            .onComplete(function () {

                                var medalEarnedDialog = new BadgeEarnedDialog(self.ui, self.parent.game,
                                    {
                                        offsetX: Absolute.Coords.x(10),
                                        offsetY: Absolute.Coords.y(10),
                                        dialog: medal.id + 'EarnedDialog',
                                        closeHandler: function () {
                                            // after dialog closes call callback
                                            if (typeof callback === 'function') {
                                                callback();
                                            }
                                        }
                                    });

                                medalEarnedDialog.open();

                                window.setTimeout(function () {
                                    try {
                                        self.parent.removeChild(emitter);
                                    } catch (e) {
                                    }
                                    emitter.destroy();
                                    emitter = null;
                                }.bind(this), 1500);

                            });

                        spiralTween.chain(medalEarnedTween);

                        this.tweens.push(spiralTween);
                        this.tweens.push(medalEarnedTween);

                    } else {
                        medal.sprite.alpha = 1;
                        medal.earned = true;
                    }
                } else {
                    medal.infoBox.coinCount.setText(this.stats.coinsEarned.toString() + ' / ' + medal.coinsNeeded.toString());
                }

            }, this);

            if (!callbackSet && typeof callback === 'function' && dirty) {
                callback();
            }

        };

        DailyChallengeProgressMeter.prototype.animateCoins = function (challengeTiles, coinsCompleteCallback) {

            if (!this.coinGlow) {

                this.coinGlow = new PIXI.DisplayObjectContainer();
                var g1 = PIXI.Sprite.fromFrame('glow.png'),
                    g2 = PIXI.Sprite.fromFrame('glow.png');
                g2.anchor.y = 1;
                g2.scale.y = -1;
                g2.y = Absolute.Coords.y(165);
                this.coinGlow.addChild(g1);
                this.coinGlow.addChild(g2);
                this.coinGlow.scale.x = this.coinGlow.scale.y = 0.5;
                this.coinGlow.alpha = 0.1;
                this.progressBar.addChild(this.coinGlow);

                this.starBurstEndClip = Absolute.SpriteUtils.loadMovieClip('coin_particles/coin_particles_', 20, 1);
                this.starBurstEndClip.anchor.x = this.starBurstEndClip.anchor.y = 0.5;
                this.starBurstEndClip.animationSpeed = 0.5;
                this.dailyChallengeMenu.menuContainer.addChild(this.starBurstEndClip);

            }
            var tileComplete = 0,
                endX = this.progressBar.x + this.barPip.x,
                endY = this.dailyChallengeMenu.progressMeter.y + this.barPip.y + this.barPip.height,
                self = this,
                coinGlowTween = new TWEEN.Tween({ alpha: 0 })
                    .easing(TWEEN.Easing.Sinusoidal.InOut)
                    .to({ alpha: 0.2 }, 10)
                    .onUpdate(function () {
                        self.coinGlow.alpha = this.alpha;
                    })
                    .repeat(Infinity)
                    .yoyo(true);
            this.starBurstEndClip.visible = false;
            this.starBurstEndClip.loop = true;
            this.starBurstEndClip.x = endX;
            this.starBurstEndClip.y = endY;
            this.coinGlow.x = this.barPip.x - Absolute.Coords.y(53);
            this.coinGlow.y = this.barPip.y - Absolute.Coords.y(82);
            this.coinGlow.visible = false;

            _.each(challengeTiles, function (challengeTile) {

                var startX = challengeTile.x + challengeTile.width / 2 + this.dailyChallengeMenu.lobbyMenu.x,
                    startY = challengeTile.y + challengeTile.height / 2 + this.dailyChallengeMenu.lobbyMenu.y,
                    coinCompleteCount = 0,
                    coinClips = [],
                    starBurstClip = Absolute.SpriteUtils.loadMovieClip('coin_particles/coin_particles_', 20, 1);


                if (this.triggerBonus && challengeTiles.length > 1) {
                    challengeTile.addRibbon(function () {
                    });
                }

                _.times(15, function () {
                    var clip = Absolute.SpriteUtils.loadMovieClip('dailychallenge/coin-flip-solitiare_', 5, 1);
                    clip.anchor.x = clip.anchor.y = 0.5;
                    clip.animationSpeed = 0.25;
                    clip.gotoAndStop(0);
                    coinClips.push(clip);
                    this.movieClipLayer.addChild(clip);
                }, this);

                starBurstClip.play();
                starBurstClip.anchor.x = starBurstClip.anchor.y = 0.5;
                starBurstClip.x = startX;
                starBurstClip.y = startY;
                starBurstClip.animationSpeed = 0.5;
                this.movieClipLayer.addChild(starBurstClip);

                _.each(coinClips, function (clip, index) {

                    clip.x = startX;
                    clip.y = startY;
                    clip.alpha = 0;

                    var coinTween = new TWEEN.Tween({ scale: 0.25, x: startX, y: startY })
                        .delay(200 * index)
                        .easing(TWEEN.Easing.Quadratic.InOut)
                        .to({ x: endX, y: endY, scale: [1.5, 0.25] }, 1800)
                        .onStart(function () {
                            clip.gotoAndPlay(Math.round(Math.random() * 4));
                            clip.alpha = 1;
                            if (index === coinClips.length - 1) {
                                starBurstClip.visible = false;
                                starBurstClip.gotoAndStop(0);
                            }
                        })
                        .onUpdate(function () {
                            clip.x = this.x;
                            clip.y = this.y;
                            clip.scale.x = clip.scale.y = this.scale;
                        })
                        .onComplete(function () {
                            clip.alpha = 0;
                            coinCompleteCount++;
                            if (coinCompleteCount === 1) {
                                self.starBurstEndClip.visible = true;
                                self.starBurstEndClip.play();
                                self.coinGlow.visible = true;
                                coinGlowTween.start();
                            } else if (coinCompleteCount >= coinClips.length && coinsCompleteCallback) {

                                tileComplete++;

                                if (tileComplete >= challengeTiles.length) {

                                    // puting this in the fadeout callback causes issues with closures that I couldn't
                                    // figure out. It caused the fadeout callback to get called when this unrelated tween
                                    // is stopped.
                                    coinGlowTween.stop();

                                    fadeOut(self.starBurstEndClip, 200, function () {
                                        self.starBurstEndClip.visible = false
                                        self.starBurstEndClip.gotoAndStop(0);
                                        self.starBurstEndClip.alpha = 1;
                                    }, 'star');

                                    fadeOut(self.coinGlow, 0, function () {
                                        self.coinGlow.visible = false;
                                        coinsCompleteCallback();
                                    }, 'coin');
                                }
                            }
                        })
                        .interpolation(TWEEN.Interpolation.Bezier)
                        .start();

                    this.tweens.push(coinTween);

                }, this);

            }, this);

            function fadeOut(item, delay, callback, id) {

                new TWEEN.Tween({ alpha: item.alpha })
                    .delay(delay || 0)
                    .easing(TWEEN.Easing.Cubic.Out)
                    .to({ alpha: 0 }, 1000)
                    .onUpdate(function () {
                        item.alpha = this.alpha;
                    })
                    .onComplete(function () {
                        if (typeof callback === 'function') {
                            callback();
                        }
                    })
                    .start();

            };

        };

        DailyChallengeProgressMeter.getDaysRemaining = function () {
            var today = new Date(),
                lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();

            return lastDay - today.getDate();
        };

        DailyChallengeProgressMeter.prototype.buildLabels = function () {
            const padding = Absolute.Coords.x(15);

            const daysRemainingLabel = new PIXI.Text(Absolute.StringManager('DailyChallenge.daysRemaining'), this.config.letterStyle1);
            const coinsLabel = new PIXI.Text(Absolute.StringManager('DailyChallenge.coins'), this.config.letterStyle3);
            const challengesCompletedLabel = new PIXI.Text(Absolute.StringManager('DailyChallenge.challengesCompleted'), this.config.letterStyle3);

            if (Absolute.StringManager.getUserLanguage() === "fr-CA" || Absolute.StringManager.getUserLanguage() === "fr-FR") {
                this.progressLabel = new PIXI.Text(Absolute.StringManager('DailyChallenge.progress') + ' ' + this.config.month.toLowerCase(), this.config.letterStyle2);
                this.daysRemainingValue = new PIXI.Text(DailyChallengeProgressMeter.getDaysRemaining().toString(), this.config.letterStyle1);
            }
            else {
                this.progressLabel = new PIXI.Text(this.config.month + ' ' + Absolute.StringManager('DailyChallenge.progress'), this.config.letterStyle2),
                    this.daysRemainingValue = new PIXI.Text(DailyChallengeProgressMeter.getDaysRemaining().toString(), this.config.letterStyle1);
            }

            this.coinsValue = new PIXI.Text('0', this.config.letterStyle3);
            this.challengesCompleteValue = new PIXI.Text('0', this.config.letterStyle3);

            daysRemainingLabel.x = this.progressLabel.x = challengesCompletedLabel.x = Absolute.Coords.x(this.config.padding * 2);
            this.daysRemainingValue.x = daysRemainingLabel.x + daysRemainingLabel.width + Absolute.Coords.x(this.config.textSpacing);
            this.daysRemainingValue.y = daysRemainingLabel.y = Absolute.Coords.y(
                this.config.padding + this.config.spacing) + this.progressBar.height;
            // this.daysRemainingValue.anchor.y = 1;

            this.progressLabel.y = Absolute.Coords.y(
                this.config.height - this.config.padding - this.config.spacing) - this.challengesCompleteValue.height;
            this.progressLabel.anchor.y = 1;
            
            this.challengesCompleteValue.y = challengesCompletedLabel.y =
                Absolute.Coords.y(this.config.height - this.config.padding);

            this.coinsValue.y = coinsLabel.y =
                Absolute.Coords.y(this.config.height - this.config.padding);
            this.challengesCompleteValue.anchor.y = challengesCompletedLabel.anchor.y =
                this.coinsValue.anchor.y = coinsLabel.anchor.y = 1;

            this.challengesCompleteValue.x = challengesCompletedLabel.x + challengesCompletedLabel.width + Absolute.Coords.x(this.config.textSpacing);


            // challengesCompletedLabel.x = Absolute.Coords.x((this.config.width - challengesCompletedLabel.width) / 2);

            var threeSliceOptions = {
                multistate: true,
                images: {
                    left: 'MS_3slice_btn_black_01.png',
                    center: 'MS_3slice_btn_black_02.png',
                    right: 'MS_3slice_btn_black_03.png'
                }
            };
            var labelOptions = {
                font: Absolute.ScreenMetrics.getResScale() * 25 + "px Arial",
                maxWidth: Absolute.ScreenMetrics.getResScale() * 150,
                fontFamily: 'segoe',
                fill: '#ffffff',
                align: 'left',
                anchor: {
                    x: 0.5,
                    y: 0.5
                },
                x: Absolute.Coords.x(90),
                y: Absolute.Coords.y(40) // button height /2
            };

            this.awardsButton = new NineSliceButton(
                'warning_dialogues/popup_button_Cancel_click.png',
                'warning_dialogues/popup_button_Cancel_over.png', 'warning_dialogues/popup_button_Cancel.png',
                Absolute.Coords.x(180), Absolute.Coords.y(80), 25, 25, 25, 25, _s('Awards'), labelOptions);
            this.awardsButton.position.x = Absolute.Coords.x(
                this.config.width - this.config.padding) - this.awardsButton.width * this.config.scale;
            this.awardsButton.position.y = Absolute.Coords.y(
                this.config.height - this.config.padding) - this.awardsButton.height * this.config.scale;
                this.awardsButton.onClick.add(function () {
                Absolute.AudioManager.playSound('button');
                this.dailyChallengeMenu.game.navAwards();
            }.bind(this));
            // TODO: Fix NineSliceButton, it can not handle an achor adjustment.
            // this.awardsButton.anchor.x = this.awardsButton.anchor.y = 1; 
            this.awardsButton.scale.x = this.awardsButton.scale.y = this.config.scale;

            // this.coinsValue.anchor.x = 1; 
            // coinsLabel.anchor.x = 1; 
            coinsLabel.x = this.awardsButton.x - coinsLabel.width - this.config.spacing * 8;
            this.coinsValue.x = coinsLabel.x + coinsLabel.width + this.config.textSpacing;

            // coinsLabel.x = this.config.width + this.challengesCompleteValue.width + this.config.spacing * 2;
            // this.coinsValue.x = coinsLabel.x + coinsLabel.width + this.config.textSpacing;

            this.addChild(daysRemainingLabel);
            this.addChild(this.daysRemainingValue);
            this.addChild(this.progressLabel);
            this.addChild(coinsLabel);
            this.addChild(this.coinsValue);
            this.addChild(challengesCompletedLabel);
            this.addChild(this.challengesCompleteValue);
            this.addChild(this.awardsButton);

            this.controls.push(this.awardsButton);
            this.focusSetter(this.awardsButton);
        };

        DailyChallengeProgressMeter.prototype.updateStats = function (forcedUpdate) {

            SolitaireDailyChallengeService.GetChallengeSettingsForCurrentMonth(
                function (monthSettings) {
                    this.currentDate = SolitaireDailyChallengeService.GetDateIndex(this.dailyChallengeMenu.date);

                    // hack. push the diamond badge into the Badges settings array
                    if (monthSettings.DiamondBadge) {
                        monthSettings.Badges.push(monthSettings.DiamondBadge);
                    }

                    this.totalPossibleCoins = monthSettings.MaximumCoins || 34700;

                    function getCoinsNeeded(medalKey) {
                        return _.result(_.find(monthSettings.Badges, function (setting) {
                            return setting.Key === medalKey;
                        }), 'CoinsNeeded');

                    };

                    _.each(this.medalsData, function (medal) {
                        medal.coinsNeeded = getCoinsNeeded(medal.id);
                    }, this);

                    var storedStats = SolitaireDailyChallengeService.GetChallengeStatsForCurrentMonth();

                    // push in bonus earned info for the current date
                    storedStats[this.currentDate + '_challengesComplete'] = SolitaireDailyChallengeService.GetCompletedChallengeCountForDate(this.dailyChallengeMenu.date) >= 5;
                    storedStats['perfectMonth'] = storedStats.coinsEarned === storedStats.totalCoins;

                    if (!this.stats) {
                        this.stats = _.clone(storedStats);
                    } else {
                        _.each(storedStats, function (stat, key) {
                            this.stats[key + '_old'] = this.stats[key];
                            this.stats[key + '_dirty'] = this.stats[key] !== stat;
                            this.stats[key] = stat;
                        }, this);
                    }

                    // if all challenges were just completed adjust coins earned so that we can animate the bonus seperately
                    this.triggerBonus = this.stats[this.currentDate + '_challengesComplete_dirty'] && this.stats[this.currentDate + '_challengesComplete'] && this.stats['coinsEarned_dirty'];
                    if (this.triggerBonus) {
                        var bonusAmount = this.dailyChallengeMenu.challengeTiles[0].challenge.dailyBonus;
                        this.stats[this.currentDate + '_bonus'] = bonusAmount;
                        this.stats.coinsEarned -= bonusAmount;
                    }
                }.bind(this),
                function () {
                    Absolute.Debug.log("Error: GetChallengeSettingsForCurrentMonth()");
                }
            );

        };

        DailyChallengeProgressMeter.prototype.bindInteraction = function (sprite, handler) {

            sprite.interactive = true;
            sprite.buttonMode = true;

            if (Absolute.Platform.supportsTouch()) {
                sprite.touchstart = handler.bind(this);
                if (Absolute.Platform._isWindows() || (Absolute.Platform._isMac() && !Absolute.Platform._isIOS())) {
                    sprite.mousedown = handler.bind(this);
                }
            } else {
                sprite.mousedown = handler.bind(this);
            }

            sprite.handleActivate = handler.bind(this)
        };

        DailyChallengeProgressMeter.prototype.onShow = function (forceUpdate) {
            this.updateStats(forceUpdate);

            if (!this.particleLayer) {
                this.particleLayer = new PIXI.DisplayObjectContainer();
                this.progressBar.addChild(this.particleLayer);
            }

            if (!this.movieClipLayer) {
                this.movieClipLayer = new PIXI.DisplayObjectContainer();
                this.dailyChallengeMenu.menuContainer.addChildAt(this.movieClipLayer, this.dailyChallengeMenu.menuContainer.children.length - 1);
                this.dailyChallengeMenu.menuContainer.setChildIndex(this.movieClipLayer, this.dailyChallengeMenu.menuContainer.children.length - 1);
            }
            this.dailyChallengeMenu.handleResize();

            if (forceUpdate) {
                this.updateProgress();
            }
        };

        DailyChallengeProgressMeter.prototype.onHide = function () {

            var forceUpdate = false;

            if (this.particleLayer && this.progressBar) {
                this.progressBar.removeChild(this.particleLayer);
                this.particleLayer = null;
            }

            if (this.movieClipLayer) {
                this.dailyChallengeMenu.menuContainer.removeChild(this.movieClipLayer);
                this.movieClipLayer = null;
            }

            if (this.starBurstEndClip) {
                this.starBurstEndClip.visible = false;
                this.starBurstEndClip.stop();
            }

            if (this.coinGlow) {
                this.coinGlow.visible = false;
            }

            _.each(this.tweens, function (tween) {
                tween.stop();
                forceUpdate = true;
            });

            // This moves the progress meter to the correct position and coins count so the right amount if
            // animations were interrupted.
            this.updateStats();
            this.updateProgress();

            this.tweens.length = 0;
            TWEEN.removeAll();

            setTimeout(function () {
                Absolute.AudioManager.stopAll();
            }, 300);

        };

        DailyChallengeProgressMeter.prototype._focusChanged = function (obj) {
            if (obj._hasFocus) {
                obj.focusIndicator = new PIXI.Graphics();
                obj.focusIndicator.lineStyle(Absolute.Coords.x(3), 0xFFFFFF);
                var marginX = -obj.width * obj.anchor.x;
                obj.focusIndicator.drawRect(marginX, 0, obj.width, obj.height);
                obj.addChild(obj.focusIndicator);
            } else {
                if (obj.children.indexOf(obj.focusIndicator) !== -1) {
                    obj.removeChild(obj.focusIndicator);
                }
            }
        };

        DailyChallengeProgressMeter.prototype.onDateChange = function (month) {
            this.daysRemainingValue.setText(DailyChallengeProgressMeter.getDaysRemaining().toString());

            if (Absolute.StringManager.getUserLanguage() === "fr-CA" || Absolute.StringManager.getUserLanguage() === "fr-FR")
                this.progressLabel = new PIXI.Text(Absolute.StringManager('DailyChallenge.progress') + ' ' + this.config.month.toLowerCase(), this.config.letterStyle2);
            else
                this.progressLabel = new PIXI.Text(this.config.month + ' ' + Absolute.StringManager('DailyChallenge.progress'), this.config.letterStyle2);
        };

        return DailyChallengeProgressMeter;

    });

